import { createUseStyles } from 'react-jss';

const useStyle = createUseStyles((theme) => ({
  tabLabel: (props) => ({
    maxWidth: '100%',
    backgroundColor: 'transparent',
    border: 'none',
    color: theme.colors.gray.normal,
    padding: `0 ${theme.sizes.base * 2}px`,
    borderBottom: 'solid 2px transparent',
    '&.selected': {
      color: theme.colors[props._color].normal,
      borderBottom: `solid 2px ${theme.colors[props._color].normal}`,
    },
  }),
}));

export default useStyle;
